var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 5.21484C15.7092 5.21484 20.0353 8.79506 20.0353 11.5006C20.0353 14.2061 15.7092 17.7863 10.9996 17.7863C6.28996 17.7863 1.96387 14.2061 1.96387 11.5006C1.96387 8.79506 6.28996 5.21484 10.9996 5.21484ZM10.9996 6.78627C7.09908 6.78627 3.5353 9.73561 3.5353 11.5006C3.5353 13.2655 7.09908 16.2148 10.9996 16.2148C14.9001 16.2148 18.4639 13.2655 18.4639 11.5006C18.4639 9.73561 14.9001 6.78627 10.9996 6.78627ZM10.9996 8.3577C12.7353 8.3577 14.1424 9.76481 14.1424 11.5006C14.1424 13.2363 12.7353 14.6434 10.9996 14.6434C9.26383 14.6434 7.85672 13.2363 7.85672 11.5006C7.85672 9.76481 9.26383 8.3577 10.9996 8.3577ZM10.9996 9.92913C10.1317 9.92913 9.42815 10.6327 9.42815 11.5006C9.42815 12.3684 10.1317 13.072 10.9996 13.072C11.8675 13.072 12.571 12.3684 12.571 11.5006C12.571 10.6327 11.8675 9.92913 10.9996 9.92913Z",
    fill: "#CAD4DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEye);
export default __webpack_public_path__ + "static/media/not-eye.31b61cedc74ede915e1acb0720810166.svg";
export { ForwardRef as ReactComponent };